import { useContent } from "contexts/contentContext/contentContext.js";
import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";

const SupportCategories = () => {
  const { getSupportText } = useContent();
  const categoriesImages = {
    "sending-files": "sending-files",
    "receiving-and-downloading-files": "download",
    subscribers: "subscribers",
    "user-profile": "user-profile",
    security: "security",
    "technical-issues": "technical-issues",
    "jumbo-pay": "jumbo-pay",
    "jumbo-embed": "jform-black2",
    "system-status": "system-status",
    download: "download",
  };
  const SupportCategory = ({ category }) => {
    if (category) {
      let categoryRoute =
        category.SystemName === "jumbo-embed"
          ? "jumbo-forms"
          : category.SystemName.toLowerCase();
      return (
        <div className="support-category">
          <a href={`support/${categoryRoute}`} className="support-category-link">
            <div className="support-category-icon-con">
              <Image
                name={`support/${categoriesImages[category.SystemName]}`}
                ext="svg"
                className="support-category-icon"
                alt=""
                title=""
              />
            </div>
            <div className="support-category-title">
              <h2>
                {category.CategoryTitle === "JUMBOembed"
                  ? "JUMBOforms"
                  : category.CategoryTitle}
              </h2>
            </div>
            <div className="support-plus-icon-con">
              <Icon name="plus" className="support-plus-icon" />
            </div>
          </a>
        </div>
      );
    }
  };
  return (
    <div className="support-categories">
      {getSupportText().categories &&
        getSupportText().categories.map((category, i) => (
          <SupportCategory category={category} key={i} />
        ))}
    </div>
  );
};

export default SupportCategories;
